import { default as React } from "react";
import { useForm } from "react-hook-form";

interface IRecoveryForm {
  onSubmit: (data: any) => void;
}

export default function RecoveryForm(props: IRecoveryForm) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="steps__form">
        <div className="steps__form_boxing">
          <div className="row">
            <div className="col-lg-12">
              <div className="form__item">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="Email"
                  {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
                />
                {errors.email && <span className="erorrs">Please, enter a valid email!</span>}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="steps__form_footer">
              <button type="submit" className="button button_bg_red steps-form__submit">
                Restore!
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
